import {
  ApiNoteInProgress,
  useGetByTenantNoteInprogressQuery,
  useGetByTenantNoteQuery
} from 'api/rtk-api'
import clsx from 'clsx'
import { AlertWrapper, EmptyDetail, Tabs } from 'components/core-v2'
import { Route, Routes, useParams } from 'react-router-dom'

import { PATH, TENANT } from '../../../const'
import { ActivationTab } from './activation-tab'
import classes from './details.module.scss'
import { NoteDetailsTab } from './note-details-tab'
import { TopUpWithdrawTab } from './top-up-withdraw-tab'

const Empty = () => {
  const { data, isLoading } = useGetByTenantNoteInprogressQuery({
    tenant: TENANT,
    pageSize: 20,
    pageNumber: 1
  })
  if (isLoading) return null
  return <EmptyDetail amount={data.totalDocuments} word="note" />
}

interface NoteTabsProps {
  inProgressNote: ApiNoteInProgress
}
const NoteTabs = ({ inProgressNote }: NoteTabsProps) => {
  const { noteId, tab } = useParams()

  return (
    <Tabs.List className={classes.tabList}>
      <Tabs.Tab
        isSelected={tab === 'activation'}
        to={PATH.noteApprovalsSingleNote(noteId, 'activation')}
        value="activation"
      >
        Activation process
      </Tabs.Tab>
      <Tabs.Tab
        isSelected={tab === 'top-up-withdraw'}
        to={PATH.noteApprovalsSingleNote(noteId, 'top-up-withdraw')}
        value="top-up-withdraw"
      >
        {inProgressNote.ongoingInstructionType === 'Deposit' ? 'Top up' : 'Withdrawal'}
      </Tabs.Tab>
      <Tabs.Tab
        isSelected={tab === 'details'}
        to={PATH.noteApprovalsSingleNote(noteId, 'details')}
        value="details"
      >
        Details
      </Tabs.Tab>
    </Tabs.List>
  )
}

const Details = () => {
  const { noteId, tab } = useParams()

  const { data: noteData, isLoading: isNoteLoading } = useGetByTenantNoteQuery({
    tenant: TENANT
  })

  const { data: inProgressData, isLoading: isInProgressLoading } =
    useGetByTenantNoteInprogressQuery({
      tenant: TENANT,
      pageSize: 1000,
      pageNumber: 1
    })

  const isLoading = isNoteLoading || isInProgressLoading

  if (isLoading) return null

  const note = noteData.find(note => note.noteId === noteId)
  const inProgressNote = inProgressData.data.find(note => note.noteId === noteId)

  if (!note || !inProgressNote) return null

  return (
    <div className={classes.root}>
      <h2>{note.noteName}</h2>
      {note.isCollateralForLoan && (
        <AlertWrapper className={clsx('ml-8', classes.collateralAlert)}>
          <span>This note is used as collateral for a loan</span>
        </AlertWrapper>
      )}
      <NoteTabs inProgressNote={inProgressNote} />
      {tab === 'activation' && (
        <Tabs.Panel className={classes.tabPanel} value="activation">
          <ActivationTab inProgressNote={inProgressNote} />
        </Tabs.Panel>
      )}
      {tab === 'top-up-withdraw' && (
        <Tabs.Panel className={classes.tabPanel} value="top-up-withdraw">
          <TopUpWithdrawTab inProgressNote={inProgressNote} />
        </Tabs.Panel>
      )}
      {tab === 'details' && (
        <Tabs.Panel className={classes.tabPanel} value="details">
          <NoteDetailsTab />
        </Tabs.Panel>
      )}
    </div>
  )
}

export const DetailsRoutes = () => (
  <Routes>
    <Route element={<Empty />} path="" />
    <Route element={<Details />} path=":noteId/:tab/:activationTab?" />
  </Routes>
)
